import { routes as profileRoutes } from 'modules/Profile/routing'

const routes = {
  root: `${profileRoutes.root}/activity-log`,
}

export default routes
